module.exports = __webpack_public_path__ + "distribution/img/xiajia.74fc43c5.png";